import React, { Fragment } from 'react';
import { useForgotUserNameContainer } from './ForgotUsernameContainer';
import LocaleUtils from 'react-day-picker/moment';
import Modal from 'react-modal';
import { withRouter } from 'react-router-dom';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';
import Input from '../../TravellerContactInfo/FormFields/Input';
import '../LoginModalsSinglePanel.css';
import '../../../../listing/components/RailDatePicker/dayPickerRailReset.css';
import { customStyles, UserFlowModalState } from '../../UserFlow/UserFlowModal'

const { formatDate, parseDate } = LocaleUtils;
const now = new Date();
const currentYear = now.getFullYear();
const currentMonth = now.getMonth();
const fromMonth = new Date(currentYear - 50, 0);
const toMonth = new Date(currentYear, currentMonth);

const YearMonthForm = ({ date, localeUtils, onChange }) => {
  const months = localeUtils.getMonths();

  const years = [];
  for (let i = fromMonth.getFullYear(); i <= toMonth.getFullYear(); i += 1) {
    years.push(i);
  }

  const handleChange = (e) => {
    const { year, month } = e.target.form;
    onChange(new Date(year.value, month.value));
  };

  return (
    <form className="DayPicker-Caption">
      <select name="month" onChange={handleChange} value={date.getMonth()}>
        {months.map((month, i) => (
          <option key={month} value={i}>
            {month}
          </option>
        ))}
      </select>
      <select name="year" onChange={handleChange} value={date.getFullYear()}>
        {years.map((year) => (
          <option key={year} value={year}>
            {year}
          </option>
        ))}
      </select>
    </form>
  );
};

const ForgotUserName = (props: UserFlowModalState) => {
  const {
    data: {
      state,
      showModal,
      validationFail,
    },

    action: {
      rotateLoader,
      handleInputKeyUpViaParent,
      closeModal,
      onDateChange,
      handleYearMonthChange,
    },
  } = useForgotUserNameContainer(props);

  const {
    month,
    disabledByEmail,
    disabledByDOB,
    rotate,
  } = state;

  const dayPickerProps = {
    month,
    fromMonth,
    toMonth,
    captionElement: ({ date, localeUtils }) => (
      <YearMonthForm
        date={date}
        localeUtils={localeUtils}
        onChange={handleYearMonthChange}
      />
    ),
    disabledDays: {
      before: fromMonth,
      after: now
    }
  };

  return (
    <Fragment>
      <Modal
        isOpen={showModal}
        ariaHideApp={false}
        onRequestClose={closeModal}
        className="loginModals loginModals--v4 dobVer"
        shouldCloseOnOverlayClick
        shouldCloseOnEsc={false}
        style={{
          overlay: {
            backgroundColor: 'rgb(0, 0, 0, 0.6)',
            zIndex: 1,
          },
          customStyles,
        }}
      >
        <p className='makeFlex spaceBetween appendBottom10'>
          <span className='modalTitle font26 latoBlack blackText'>
              Get IRCTC Username
          </span>
          <span
            className='modalClose railSprite crossIcon'
            onClick={closeModal}>
          </span>
        </p>
        <p className='additionalInfo appendBottom20 font14'>
          <span className="blackText">You will receive an email from IRCTC with your registered IRCTC userID.</span>
        </p>
        <div className={`makeFlex spaceBetween ${validationFail ? 'hrtlCenter' : 'end'}`}>
          <Input
            labelName="IRCTC Registered Email / Phone Number"
            errorMessage="Username cannot contain “!”."
            validationFail={false}
            type="text"
            additionalAttributes={{ placeholder: 'Email ID or Phone Number' }}
            fieldId="IRCTCUserEmail"
            fieldName="IRCTCUserEmail"
            vaidationMsg=""
            vaidationMoreMsg={null}
            vaidationMoreStatus={false}
            vaidationStatus={true}
            readOnly={false}
            textStyle={'blackText font14 latoBlack InputFieldElement'}
            style={'darkGreyText labelName greyed latoBold font14'}
            handleInputKeyUpViaParent={handleInputKeyUpViaParent}
          />
        </div>
        <div className="appendTop20">
          <label className="font14 latoBold makeFlex InputField appendBottom10 fullWidth">
            <span className="darkGreyText labelName greyed">Date of Birth</span>
          </label>
          <div className="YearNavigation dayPickerHotelWrap appendBottom40">
            <DayPickerInput
              showOverlay={false}
              onDayChange={onDateChange}
              formatDate={formatDate}
              parseDate={parseDate}
              format="LL"
              keepFocus={true}
              placeholder="Select a Date"
              dayPickerProps={dayPickerProps}
            />
            <span className="railSprite calIcon"></span>
          </div>
        </div>
        <button
          onClick={rotateLoader}
          style={{ width: '186px', maxHeight:'35px'  }}
          className={`${disabledByEmail || disabledByDOB ? 'disabled' : ''} noShrink width220`}>
          <span className={`${rotate ? 'btnLoader' : 'font12 latoBlack whiteText capText'}`} >
            Get IRCTC ID
          </span>
        </button>
      </Modal>
    </Fragment>
  );
};

export default withRouter(ForgotUserName);
